(function($) {

var tools = (function() {
	var init = function() {
		bindEvents();
	};
	var bindEvents = function() {
		$('body').on('mousedown', 'img', function() {
			return false;
		});
	};
	var isDesktop = function() {
		return ( $(window).width() >= 992) ;
	};
	var isTablet = function() {
		return ( $(window).width() < 992 && $(window).width() >= 768) ;
	};
	var isSmartphone = function() {
		return ( $(window).width() < 768) ;
	};
	var isIOS = function() {
		var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		return isIOS;
	};
	var isMobile = function() {
		return $('html').hasClass('is-handheld');
	};
	return {
		init: init,
		isDesktop: isDesktop,
		isTablet: isTablet,
		isSmartphone: isSmartphone,
		isIOS: isIOS
	};
})();

var site = (function() {
	var pageOpeningWait = true;
	var siteIsLoading   = true;
	var currentURL      = window.location.href;
	var siteIntroDelay  = 0;
	var initTime        = Date.now();
	var pageHeight      = $(window).innerHeight();
	var init            = function() {
		tools.init();
		bindEvents();
		pageInit();
	};

	/*
	########  ##     ##  ########  ##    ##  ########   ######    
	##        ##     ##  ##        ###   ##     ##     ##    ##   
	##        ##     ##  ##        ####  ##     ##     ##         
	######    ##     ##  ######    ## ## ##     ##      ######    
	##         ##   ##   ##        ##  ####     ##           ##   
	##          ## ##    ##        ##   ###     ##     ##    ##   
	########     ###     ########  ##    ##     ##      ######    
	*/

	var debounce = function(wait, immediate, func) {

		var timeout;

		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	var addEndEvent = debounce(200, false, function(e) {
		$(this).trigger(e.type + 'End');
	});

	var bindEvents = function() {
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler);
		$('body').on('reveal', '.scroll-reveal', scrollRevealHandler);
	};

	/*
	 ######    ####  ########   ########   ##          #######      ###     ########   ########   ########   
	##    ##    ##      ##      ##         ##         ##     ##    ## ##    ##     ##  ##         ##     ##  
	##          ##      ##      ##         ##         ##     ##   ##   ##   ##     ##  ##         ##     ##  
	 ######     ##      ##      ######     ##         ##     ##  ##     ##  ##     ##  ######     ##     ##  
		  ##    ##      ##      ##         ##         ##     ##  #########  ##     ##  ##         ##     ##  
	##    ##    ##      ##      ##         ##         ##     ##  ##     ##  ##     ##  ##         ##     ##  
	 ######    ####     ##      ########   ########    #######   ##     ##  ########   ########   ########   
	*/
	var siteLoaded = function() {
		siteIsLoading = false;
		pageInit();
	};

	/*
	##     ##     ###     ##    ##   ########   ##         ########   ########    ######    
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  ##    ##   
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  ##         
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########    ######    
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##          ##   
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##   ######    
	*/
	var resizeHandler = function() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();
	};

	var scrollHandler = function() {
		var scrollTop = $(window).scrollTop();
	};

	var pageInit = function() {
		initParallax();
		$(window).trigger('resize');
	};

	var initScrollAnimations = function() {
		var controllerScroll = new ScrollMagic.Controller();
		
		$('body .scroll-reveal').each(function() {
			var element = $(this);
			var offset  = element.offset().top;
			var windowHeight  = $(window).height();
			var scene   = new ScrollMagic.Scene({
				triggerHook: "onLeave",
				offset: offset - ( windowHeight * 0.85 ),
				reverse: false
			});
			scene.on('start', function(e) {
				if (e.scrollDirection != 'REVERSE') {
					element.trigger('reveal');
					scene.remove();
				}
			});
			scene.addTo(controllerScroll);
		});	
		$('body').data('scrollController', controllerScroll);
	};

	/*
	########   ########   ##     ##  ########      ###     ##         
	##     ##  ##         ##     ##  ##           ## ##    ##         
	##     ##  ##         ##     ##  ##          ##   ##   ##         
	########   ######     ##     ##  ######     ##     ##  ##         
	##   ##    ##          ##   ##   ##         #########  ##         
	##    ##   ##           ## ##    ##         ##     ##  ##         
	##     ##  ########      ###     ########   ##     ##  ########   
	*/
	var scrollRevealHandler = function() {
		var element = $(this);

		if (element.hasClass('is-revealed'))
			return;

		if (element.is('.text')) {
			splitTitle = new SplitText(element.find('span'),{
				type:       'words',
				wordsClass: 'split-word'
			});

			lines = element.find('span');
			words = element.find('.split-word');

			words.css({
				opacity: 0
			});
			element.find('span').css({
				opacity: 1
			});

			element.addClass('is-revealed');

			tl = new TimelineLite();
			tl.pause();

			tl.fromTo(arrow, 1, {
				alpha: 0
			}, {
				alpha: 1,
			});

			lines.each(function(index) {
				var line = $(this);
				tl.fromTo(line.find('.split-word'), 0.8, {
					alpha: 0,
					top: line.height()
				}, {
					alpha: 1,
					top: 0,
					ease: Power3.easeOut
				}, 0 + (index * 0.1));
			});
			tl.call(function() {
				splitTitle.revert();
			});
			tl.play();
		} else if (element.is('.lined-text')) {
			splitTitle = new SplitText(element.find('p'),{
				type:       'lines',
				linesClass: 'split-line'
			});

			lines = element.find('.split-line');

			lines.css({
				opacity: 0
			});
			element.find('p').css({
				opacity: 1
			});

			element.addClass('is-revealed');

			tl = new TimelineLite();
			tl.pause();

			tl.fromTo(arrow, 1, {
				alpha: 0
			}, {
				alpha: 1,
			});

			lines.each(function(index) {
				var line = $(this);
				tl.fromTo( line, 0.8, {
					alpha: 0,
					top: line.height()
				}, {
					alpha: 1,
					top: 0,
					ease: Power3.easeOut
				}, 0 + (index * 0.1));
			});
			tl.call(function() {
				splitTitle.revert();
			});
			tl.play();
		} else if (element.is('.editor-text')) {
			p = $(this).find('p, li');
					
			element.addClass('is-revealed');

			p.css({
				opacity: 0
			});

			tl = new TimelineLite();
			tl.pause();
			
			p.each(function(index) {
				tl.fromTo($(this), 0.8, {
					alpha: 0,
					y: 20
				}, {
					alpha: 1,
					y: 0,
					ease: Power3.easeOut
				}, 0 + (index * 0.1));
			});
			tl.play();
		} else if (element.is('.stagger-show')) {
			element.addClass('is-revealed');

			square = $(this).find('.stagger-show-item');

			var duration = 0.5;
			var stagger  = 0.2;
			var animationClass = 'show';
			TweenMax.staggerTo(square, duration, {className: '+=' + animationClass}, stagger);
		}
	};

	/*
	########      ###     ########      ###     ##         ##            ###     ##     ##  
	##     ##    ## ##    ##     ##    ## ##    ##         ##           ## ##     ##   ##   
	##     ##   ##   ##   ##     ##   ##   ##   ##         ##          ##   ##     ## ##    
	########   ##     ##  ########   ##     ##  ##         ##         ##     ##     ###     
	##         #########  ##   ##    #########  ##         ##         #########    ## ##    
	##         ##     ##  ##    ##   ##     ##  ##         ##         ##     ##   ##   ##   
	##         ##     ##  ##     ##  ##     ##  ########   ########   ##     ##  ##     ##  
	*/
	var ctrlParallax;
	var sceneParallax = [];
	var initParallax = function() {
		if ( $(window).width() > 768 ) {
			ctrlParallax = new ScrollMagic.Controller();
			$('body').addClass('ctrlParallax');
		}

		$('.parallax').each(function( index ) {
			$(this).css({ transform: '' });
			
			if ( $(window).width() > 768 ) {
				var start      = $(this).attr( 'data-start' );
				var end        = $(this).attr( 'data-end' );
				var direction  = $(this).attr( 'data-direction' );
				if ( start     === undefined ) start = 0;
				if ( end       === undefined ) end = 0;
				if ( direction === undefined ) direction = "vertical";

				var windowHeight  = $(window).height();
				var elementOffset = $(this).offset().top;
				var elementHeight = $(this).outerHeight();
				var offset        = ( elementOffset - windowHeight );
				
				var tween;
				if ( direction == 'horizontal' ) {
					tween = TweenMax.fromTo( this, 1, { x: start }, { x: end, ease: Power0.easeNone } );
				} else {
					tween = TweenMax.fromTo( this, 1, { y: start }, { y: end, ease: Power0.easeNone } );
				}
				
				sceneParallax[index] = new ScrollMagic.Scene({
					offset: offset,
					triggerHook: 'onEnter'
				})
				.setTween( tween )
				.addTo( ctrlParallax );
			}
		});
	};

	var resizeParallax = function() {
		if ( $(window).width() > 768 )  {
			if ( ! $('body').hasClass('ctrlParallax') ) {
				initParallax();
			} else {
				ctrlParallax.enabled(true);
				ctrlParallax.update(true);
			}
		} else {
			if ( $('body').hasClass('ctrlParallax') ) {
				$('body').removeClass('ctrlParallax');
				ctrlParallax.destroy(true);
			}
		}

		if ( $(window).width() > 768 ) {
			if ( ctrlParallax.enabled() ) {
				$('.parallax').each(function( index ) {
				
					var elementDuration  = $(this).attr( 'data-duration' );
					if ( elementDuration === undefined ) elementDuration = 1;

					var windowHeight  = $(window).height();
					var elementOffset = $(this).offset().top;
					var elementHeight = $(this).outerHeight();
					var offset        = ( elementOffset - windowHeight );
					var duration      = ( windowHeight  + elementHeight );

					sceneParallax[index].duration(duration);
					sceneParallax[index].offset(offset);
					sceneParallax[index].update(true);
				}); 
			} 
		} else {
			$('.parallax').each(function( index ) {
				$(this).css({ transform: '' });
			});
		}	
	};

	return {
		init: init
	};

// END SITE
})();
site.init();
	

/*
########    #######   ########   ##     ##  
##         ##     ##  ##     ##  ###   ###  
##         ##     ##  ##     ##  #### ####  
######     ##     ##  ########   ## ### ##  
##         ##     ##  ##   ##    ##     ##  
##         ##     ##  ##    ##   ##     ##  
##          #######   ##     ##  ##     ##  
*/
$('.form-field input, .form-field textarea').focus(function(){
	$(this).closest('div').addClass('current');
}).blur(function() {
	$(this).closest('div').removeClass('current');
	if( $(this).val() ) {
		$(this).closest('div').addClass('filled');
	} else {
		$(this).closest('div').removeClass('filled');
	}
});

$('.form-field select option:first-child').addClass('hidden').empty();

// Show new spinner on submit
$('.wpcf7-submit').on('click', function () {
	$(this).closest('form').append('<div class="ajax-form-loader" />');
	$('.ajax-form-loader').addClass('visible');
});

// Hide new spinner on result
$('div.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed', function () {
	$('.ajax-form-loader').removeClass('visible').remove();
});

const downloadForms = document.querySelectorAll(".contact-form-download");
downloadForms.forEach( function (elem) {
	const form = elem.querySelector('.wpcf7');
	form.addEventListener('wpcf7mailsent', function (e) {
		elem.classList.add("success");
	});
});

/**
 * Data-link
 */
$('[data-link]').click(function() {
	if( $(this).attr('target') ){
		window.open( $(this).data("link") , $(this).attr('target'));
	}else{
		window.location.href = $(this).data('link');
	}
}).find('a').click(function(e) {
	e.stopPropagation();
});

/**
 * Test si les Media Queries sont supportées
 * Ajoute la classe 'mq' au tag HTML si c'est le cas
 */
if ( Modernizr.mq('only all') ) {
		jQuery('html').addClass('mq');
} else {
		jQuery('html').addClass('no-mq');
}

/**
 * MatchHeight [GRID]
 */
$(".harmonize").matchHeight();
$(".harmonize-alt").matchHeight();
$(".content-section--intro > ul > li").matchHeight();

// Fitvids
$('.fitvids').fitVids();

/**
 * Fix menu onscroll
 */
if ( $(window).width() > 767 ) {
	var sticky = new Waypoint.Sticky({
		element: $('.header__main--container')[0]
	});

	// var sticky = new Waypoint.Sticky({
	// 	element: $('.header')[0]
	// })
}

/**
 * Toggle menu
 */
$(".nav-toggle").click(function(e){
	e.preventDefault();
	$(".nav-main").toggleClass("open");
	$(".lines-button").toggleClass("close");
});

$('li.blog a').each(function(){
	$(this).html('<span class="icon">'+ $(this).html() +'</span><span class="border"><span><em></em></span><span><em></em></span></span>');
});

/**
 * Slider Témoignages [Owl Carousel]
 */
var sliderTestimony = $('.testimony-block .owl-carousel');
sliderTestimony.owlCarousel({
	autoplay: true,
	items: 1,
	nav: false,
	loop: true,
	animateIn: 'slideInLeft',
	animateOut: 'slideOutLeft',
	smartSpeed: 400,
	autoHeight: true
});

$('.customNextBtn').click(function(e) {
	e.preventDefault();
	sliderTestimony.trigger('next.owl.carousel');
});

$('.customPrevBtn').click(function(e) {
	e.preventDefault();
	sliderTestimony.trigger('prev.owl.carousel');
});

/**
 * Slider Démarche [pages Métiers]
 */
var sliderDemarcheImg = $('.slick--img');
sliderDemarcheImg.slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	asNavFor: '.slick--content,.slick--img--bg',
	centerMode: false,
	focusOnSelect: true,
	prevArrow: "<a href='#' class='customPrevBtn customPrevBtn-alt'><svg class='icon-arrow-left'><use xlink:href='#arrow-left'></use></svg></a>",
	nextArrow: "<a href='#' class='customNextBtn customNextBtn-alt'><svg class='icon-arrow-right'><use xlink:href='#arrow-right'></use></svg></a>"
});

var sliderDemarcheContent = $('.slick--content');
sliderDemarcheContent.slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	asNavFor: '.slick--img',
	adaptiveHeight: true
});

var sliderDemarcheImgBg = $('.slick--img--bg');
sliderDemarcheImgBg.slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	asNavFor: '.slick--img'
});

/**
 * Zoom image actu [single news] 
 */
$('.zoom-img').magnificPopup({
	type: 'image',
	mainClass: 'mfp-zoom-in',
	//big vertical image
	image: {
		verticalFit: false
	}
});




})(jQuery);
